import BreadcrumbItem from 'Components/Atoms/BreadcrumbItem/BreadcrumbItem';
import { Container } from 'Components/Atoms/ContainerDeprecated/Container';
import Loader from 'Components/Atoms/Loader/Loader';
import Accordion from 'Components/Molecules/Accordion/Accordion';
import Breadcrumbs from 'Components/Molecules/Breadcrumbs/Breadcrumbs';
import PageHeader from 'Components/Organisms/PageHeader/PageHeader';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { getEntityDisplayValue } from 'Services/helpers';
import { ROUTE } from 'Services/Route/Route.types';
import { createDataset, fetchAllDatasets, fetchAllFields } from 'Store/FieldManagement/Actions';
import { getAllFields } from 'Store/FieldManagement/Selectors';
import FieldEntity from './FieldEntity';

const FieldsPage = ({fields, ...props}: any) => {
    const [isLoading, setLoading] = useState(Object.keys(fields)?.length <= 0);

    useEffect(() => {
        props.fetchAllFields().then(() => setLoading(false));
        props.fetchAllDatasets();
    }, []);

    return (
        <PageTemplate>
            <Helmet>
                <title>Fields Management - Growing People B.V.</title>
            </Helmet>

            <Container>
                <PageHeader
                    breadcrumbs={
                        <Breadcrumbs>
                            <BreadcrumbItem path={ROUTE.DASHBOARD}>Home</BreadcrumbItem>
                            <BreadcrumbItem path={ROUTE.SETTINGS}>Instellingen</BreadcrumbItem>
                            <BreadcrumbItem>Fields</BreadcrumbItem>
                        </Breadcrumbs>
                    }
                />

                { isLoading && <Loader description="Velden laden..." /> }

                {fields && Object.keys(fields).map((item: any, index: number) => {
                    return <Accordion title={getEntityDisplayValue(item)} key={item} isOpen={index === 0}>
                        <FieldEntity entity={item} fields={fields[item]} />
                    </Accordion>
                })}

                <br />
            </Container>
        </PageTemplate>
    )
}


export default connect(
    (state: any) => ({
        fields: getAllFields(state),
    }), {
        createDataset,
        fetchAllDatasets,
        fetchAllFields
    }
)(FieldsPage)